module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-desktop"
  }, [_c('div', {
    staticClass: "nav-desktop__navbar",
    class: {
      'nav-desktop__navbar--scrolling': _vm.$store.state.nav
    }
  }, [_c('div', {
    staticClass: "nav-desktop__navbar-item"
  }, [_c('transition', {
    attrs: {
      "name": "hamburger-fade"
    }
  }, [(_vm.$store.state.nav) ? _c('div', {
    staticClass: "nav-desktop__logo-sm-container"
  }, [_c('Icon', {
    staticClass: "nav-desktop__logo",
    attrs: {
      "name": "logo"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "nav-desktop__hamburger",
    class: {
      'nav-desktop__hamburger--active': _vm.$store.state.drawer, 'nav-desktop__hamburger--lower': _vm.$store.state.nav
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span'), _c('span'), _c('span'), _c('span')])], 1), _c('div', {
    staticClass: "nav-desktop__navbar-item"
  }, [_c('transition', {
    attrs: {
      "name": "logo-fade"
    }
  }, [(!_vm.$store.state.nav) ? _c('div', {
    staticClass: "nav-desktop__logo-lg-container"
  }, [_c('Icon', {
    staticClass: "nav-desktop__logo",
    attrs: {
      "name": "logo-inner"
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "nav-desktop__navbar-item"
  }, [_c('div', {
    staticClass: "nav-desktop__patients-btn",
    on: {
      "click": function($event) {
        _vm.showModal(1)
      }
    }
  }, [_c('span', [_vm._v("For Patients")])]), _c('div', {
    staticClass: "nav-desktop__appt-btn",
    on: {
      "click": function($event) {
        _vm.showModal(0)
      }
    }
  }, [_c('span', [_vm._v("Request Appointment")])]), _c('a', {
    staticClass: "nav-desktop__phone",
    class: {
      'nav-desktop__phone--blue': _vm.$store.state.color
    },
    attrs: {
      "href": "tel:1-406-449-5576"
    }
  }, [_c('Icon', {
    staticClass: "nav-desktop__icon",
    attrs: {
      "name": "phone-icon"
    }
  }), _c('div', {
    staticClass: "nav-desktop__phone-number"
  }, [_vm._v("406-449-5576")])], 1)]), _c('transition', {
    attrs: {
      "name": "drawer-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.drawer),
      expression: "$store.state.drawer"
    }],
    staticClass: "nav-desktop__drawer"
  }, [_c('div', {
    staticClass: "nav-desktop__drawer-container"
  }, [_c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(0)
      }
    }
  }, [_vm._v("Home")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(1)
      }
    }
  }, [_vm._v("Welcome")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(2)
      }
    }
  }, [_vm._v("About               ")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(3)
      }
    }
  }, [_vm._v("Testimonials")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(4)
      }
    }
  }, [_vm._v("Why Us")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(5)
      }
    }
  }, [_vm._v("Treatments")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": _vm.goToPayments
    }
  }, [_vm._v("Payments")]), _c('p', {
    staticClass: "nav-desktop__link",
    on: {
      "click": function($event) {
        _vm.moveTo(6)
      }
    }
  }, [_vm._v("Contact")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78647d32","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-desktop/nav-desktop.pug
// module id = 545
// module chunks = 1